<template>
  <div class="optativa-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Gestión Académica</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30">mdi-book-plus-multiple-outline</v-icon>
          </div>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-6 content-area bg-light">
            
            <v-alert v-if="user.excedente" prominent outlined type="warning" class="rounded-xl glass-card border-none mb-6">
              <strong>Fuera de Término:</strong> Ya no es posible inscribirte a materias ya que estas exento.
            </v-alert>

            <div v-else-if="cursos.length == 0 && show == true" class="text-center pa-10 bg-light-gradient rounded-xl mt-4">
              <v-icon size="64" color="grey lighten-2">mdi-book-off-outline</v-icon>
              <h3 class="text-h6 grey--text text--darken-1 mt-4">Sin materias optativas</h3>
              <p class="text-body-2 grey--text">En este momento no hay materias optativas disponibles.</p>
            </div>

            <div v-else>
              <div v-for="(curso, index) in cursos" :key="index" class="mb-8">
                <div class="d-flex align-center justify-space-between mb-4">
                  <h2 class="text-h6 font-weight-bold primary-text mb-0">
                    <v-icon color="primary" class="mr-2">mdi-school</v-icon>
                    {{ curso.Feriado }}
                  </h2>
                </div>

                <v-card class="rounded-xl border-light overflow-hidden" elevation="0">
                  <v-list class="pa-0 bg-transparent">
                    <template v-for="(planDeEstudioData, planDeEstudioDataKey) in curso.plan_de_estudio_v2">
                      <v-list-item :key="planDeEstudioDataKey" class="py-3 px-4 border-bottom hover-row">
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold primary-text">
                            {{ planDeEstudioData.Materia }}
                          </v-list-item-title>
                        </v-list-item-content>
                        
                        <v-list-item-action class="ml-4" style="min-width: 250px;">
                          <v-select
                            v-model="planDeEstudioData.materiaOptativa_id"
                            :items="optativas"
                            item-text="materia"
                            item-value="id"
                            placeholder="Seleccionar Optativa"
                            outlined
                            rounded
                            dense
                            hide-details
                            return-object
                            prepend-inner-icon="mdi-book-open-page-variant"
                            @change="saveOptativa(planDeEstudioData.materia_id, planDeEstudioData.materiaOptativa_id)"
                          ></v-select>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider :key="'div-'+planDeEstudioDataKey" v-if="planDeEstudioDataKey < curso.plan_de_estudio_v2.length - 1"></v-divider>
                    </template>
                  </v-list>
                </v-card>
              </div>
            </div>

          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Optativa",
  components: {
    CardIeaAppMain,
  },

  data: () => ({
    title: "Materias optativas",
    cursos: [],
    optativas: [],
    show: false,
  }),

  methods: {
    async saveOptativa(id, cambio) {
      if (!cambio || !cambio.id) return;
      await this.$API
        .post({
          url: "alumno/cambio-optativas",
          data: {
            id: id,
            cambio: cambio.id
          }
        })
        .then(res => {
          if (res.estado) {
            alert(res.mensaje);
            this.getMateriaOptativas();
            this.getOptativas();
          } else {
            alert(res.mensaje);
            this.getMateriaOptativas();
            this.getOptativas();
          }
        });
    },
    async getOptativas() {
      await this.$API
        .get({
          url: "optativas",
          data: {}
        })
        .then(res => {
          this.optativas = res;
        });
    },
    async getMateriaOptativas() {
      await this.$API
        .get({
          url: "alumno/materia-optativa",
          data: {}
        })
        .then(res => {
          this.cursos = res.data;
          this.show = true;
        });
    },
  },

  mounted() {
    if (this.$store.getters.user.borrado == 1 || this.$store.getters.user.alumno_mora == true || this.$store.getters.user.excedente) {
      this.$router.push({
        name: "Home"
      });
    }
    this.getMateriaOptativas();
    this.getOptativas();
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.optativa-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }
.bg-transparent { background-color: transparent !important; }

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-bottom { border-bottom: 1px solid rgba(0, 0, 0, 0.05); }

.hover-row {
  transition: background-color 0.2s ease;
}
.hover-row:hover {
  background-color: #f1f5f9 !important;
}

.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
</style>
